import { render, staticRenderFns } from "./CustomerHandover.vue?vue&type=template&id=906e2d4c"
import script from "./CustomerHandover.vue?vue&type=script&lang=js"
export * from "./CustomerHandover.vue?vue&type=script&lang=js"
import style0 from "./CustomerHandover.vue?vue&type=style&index=0&id=906e2d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
